

















































    import BaseInput from '../models/base.input';
    import Component from 'vue-class-component';
    import PhoneFormatter from '../helpers/phone.formatter';
    import { Watch, Prop } from 'vue-property-decorator';

const FULL_PHONE_LENGTH = 19;

@Component({
  props: {
    value: String,
    labelCols: Number,
    cols: Number,
    additionalCols: {
      type: Number,
      default: 2
    }
  }
})
export default class PhoneInput extends BaseInput {
  @Prop()
  value!: string;
  phone: string = '';
  additionalNumbers: string = '';

  @Watch('value')
  onValueChange() {
    if (!this.phone) {
      const formattedPhone = PhoneFormatter.format(this.value);

      this.phone = formattedPhone.substring(0, FULL_PHONE_LENGTH);

      if (formattedPhone.length > FULL_PHONE_LENGTH) {
        this.additionalNumbers = formattedPhone.substring(FULL_PHONE_LENGTH);
      }
    }

    this.$validator.validate(this.name);
  }

  clearPhone() {
    this.phone = '';
    this.value = '';
    this.additionalNumbers = '';
  }
}
